module.exports = __webpack_public_path__ + "img/cat_god.802f98d0.svg";